// src/routes/modules/subDealerRoutes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import MasterLayout from '../../masterLayout/MasterLayout';

import ViewSubDealer from '../../pages/SubDealer/ViewSubDealer';
import AddSubDealer   from '../../pages/SubDealer/AddSubDealer';
import ViewSubDealers  from '../../pages/SubDealer/ViewSubDealers';
import EditSubDealer  from '../../pages/SubDealer/EditSubDealer';

const SubDealerRoutes = (
  <>
    <Route
      path="/sub-dealer/view"
      element={
        <ProtectedRoute>
          <MasterLayout><ViewSubDealers /></MasterLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/sub-dealer/view/:id"
      element={
        <ProtectedRoute>
          <MasterLayout><ViewSubDealer /></MasterLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/sub-dealer/add"
      element={
        <ProtectedRoute>
          <MasterLayout><AddSubDealer /></MasterLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/sub-dealer/edit/:id"
      element={
        <ProtectedRoute>
          <MasterLayout><EditSubDealer /></MasterLayout>
        </ProtectedRoute>
      }
    />
  </>
);

export default SubDealerRoutes;
